import React, { useContext, useRef, useState } from 'react'
import { MeetingsContext } from '../../../context/MeetingContext'
import { Needs } from './needs'
import { QAs } from './qas'
import { FeedbacksCanvas } from './feedbacks'
import ReactPlayer from 'react-player'
import thumbnailAudioDefault from '../../../assets/audio-thumbnail.png'
import thumbnailDefault from '../../../assets/video-player-box.png'
import { Timeline } from './timeline'
import Problems from '../../project/problems/problems'
import { EditDialog } from '../../dialogs/editDialog'
import { createPortal } from 'react-dom'
import { isEmptyish } from 'remeda'

export function Canvas() {
  const [clickedPreview, setClickedPreview] = useState(false)
  const {
    url,
    thumbnail,
    meeting,
    setMeeting,
    problemsRef,
    needsRef,
    feedbackRef,
    overviewRef,
    setContainerRef,
    setProject,
    problems,
    setProblems,
    needs,
    qas,
    project,
    feedbacks,
    dialogState,
    closeDialog,
    participants,
    setNeeds,
    setFeedbacks,
    categories,
    meetingOverview,
  } = useContext(MeetingsContext)
  const nameRef = useRef()

  // Get the correct entity and setter based on dialogState.type
  const getEntityAndSetter = () => {
    switch (dialogState.type) {
      case 'need':
        return {
          entity: needs.find((n) => n.id === dialogState.noteId),
          setEntities: setNeeds,
          entityName: 'note',
        }
      case 'feedback':
        return {
          entity: feedbacks.find((f) => f.id === dialogState.noteId),
          setEntities: setFeedbacks,
          entityName: 'feedback',
        }
      case 'problem':
        return {
          entity: problems.find((p) => p.id === dialogState.noteId),
          setEntities: setProblems,
          entityName: 'problem',
        }
      default:
        return null
    }
  }

  return (
    <div className="bg-white pt-[30px] h-full overflow-auto hideScrollbar flex justify-center" ref={setContainerRef}>
      <div className="w-[720px] flex flex-col gap-[36px]">
        <div className="flex items-center justify-between" ref={overviewRef}>
          <input
            ref={nameRef}
            type="text"
            className="text-[#3f424a] bg-white text-[26px] font-semibold font-['Manrope'] leading-[29.90px] grow"
            value={meeting.name}
            onChange={(e) => setMeeting({ ...meeting, name: e.target.value })}
            onKeyDown={(e) => e.key === 'Enter' && nameRef.current.blur()}
          />
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4007_32977)">
              <path
                d="M18.6667 21.0013C19.2855 21.0013 19.879 21.2471 20.3166 21.6847C20.7542 22.1223 21 22.7158 21 23.3346C21 22.7158 21.2458 22.1223 21.6834 21.6847C22.121 21.2471 22.7145 21.0013 23.3333 21.0013C22.7145 21.0013 22.121 20.7555 21.6834 20.3179C21.2458 19.8803 21 19.2868 21 18.668C21 19.2868 20.7542 19.8803 20.3166 20.3179C19.879 20.7555 19.2855 21.0013 18.6667 21.0013ZM18.6667 7.0013C19.2855 7.0013 19.879 7.24713 20.3166 7.68472C20.7542 8.1223 21 8.7158 21 9.33463C21 8.7158 21.2458 8.1223 21.6834 7.68472C22.121 7.24713 22.7145 7.0013 23.3333 7.0013C22.7145 7.0013 22.121 6.75547 21.6834 6.31788C21.2458 5.8803 21 5.28681 21 4.66797C21 5.28681 20.7542 5.8803 20.3166 6.31788C19.879 6.75547 19.2855 7.0013 18.6667 7.0013ZM10.5 21.0013C10.5 19.1448 11.2375 17.3643 12.5503 16.0516C13.863 14.7388 15.6435 14.0013 17.5 14.0013C15.6435 14.0013 13.863 13.2638 12.5503 11.951C11.2375 10.6383 10.5 8.85782 10.5 7.0013C10.5 8.85782 9.7625 10.6383 8.44975 11.951C7.13699 13.2638 5.35652 14.0013 3.5 14.0013C5.35652 14.0013 7.13699 14.7388 8.44975 16.0516C9.7625 17.3643 10.5 19.1448 10.5 21.0013Z"
                stroke="#FF4A8E"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_4007_32977">
                <rect width="28" height="28" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        {url ? (
          <div
            className={`relative w-[720px] max-h-[340px] bg-cover bg-center flex justify-center ${clickedPreview && ''}`}
            style={{ background: `url(${thumbnail ? thumbnailDefault : thumbnailAudioDefault})` }}
          >
            <ReactPlayer
              onClickPreview={() => setClickedPreview(true)}
              url={url}
              width={720}
              height={340}
              light={
                <div className="w-full h-full relative flex justify-center">
                  <img
                    src={thumbnail || thumbnailAudioDefault}
                    alt="Thumbnail"
                    className="max-h-[340px] max-w-[720px] object-cover"
                  />
                  <button className="absolute z-10" style={{ left: 'calc(50% - 49px)', top: 'calc(50% - 53px)' }}>
                    <svg width="98" height="106" viewBox="0 0 98 106" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g filter="url(#filter0_d_3792_25601)">
                        <ellipse cx="48.5675" cy="53.0264" rx="38.419" ry="42.501" fill="white" />
                        <path
                          d="M67.4327 52.7066C67.6186 52.8728 67.6186 53.1638 67.4327 53.33L39.6638 78.1601C39.3944 78.4009 38.967 78.2097 38.967 77.8484L38.967 28.1882C38.967 27.8268 39.3944 27.6356 39.6638 27.8765L67.4327 52.7066Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_3792_25601"
                          x="0.113372"
                          y="0.490325"
                          width="96.91"
                          height="105.072"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood floodOpacity="0" result="BackgroundImageFix" />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feMorphology
                            radius="3.34502"
                            operator="dilate"
                            in="SourceAlpha"
                            result="effect1_dropShadow_3792_25601"
                          />
                          <feOffset />
                          <feGaussianBlur stdDeviation="3.34502" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3792_25601" />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_3792_25601"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </button>
                </div>
              }
              controls
            />
          </div>
        ) : (
          <div className="absolute left-1/2">
            <svg className="w-16 h-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
              <radialGradient id="a1" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
                <stop offset="0" stopColor="#FF156D"></stop>
                <stop offset=".3" stopColor="#FF156D" stopOpacity=".9"></stop>
                <stop offset=".6" stopColor="#FF156D" stopOpacity=".6"></stop>
                <stop offset=".8" stopColor="#FF156D" stopOpacity=".3"></stop>
                <stop offset="1" stopColor="#FF156D" stopOpacity="0"></stop>
              </radialGradient>
              <circle
                transform-origin="center"
                fill="none"
                stroke="url(#a1)"
                strokeWidth="15"
                strokeLinecap="round"
                strokeDasharray="200 1000"
                strokeDashoffset="0"
                cx="100"
                cy="100"
                r="70"
              >
                <animateTransform
                  type="rotate"
                  attributeName="transform"
                  calcMode="spline"
                  dur="2"
                  values="360;0"
                  keyTimes="0;1"
                  keySplines="0 0 1 1"
                  repeatCount="indefinite"
                ></animateTransform>
              </circle>
              <circle
                transform-origin="center"
                fill="none"
                opacity=".2"
                stroke="#FF156D"
                strokeWidth="15"
                strokeLinecap="round"
                cx="100"
                cy="100"
                r="70"
              ></circle>
            </svg>
          </div>
        )}

        {isEmptyish(meetingOverview) ? (
          <p className="text-gray-400 text-lg text-center py-24 font-normal font-manrope">
            Hang tight! We&apos;re processing insights from this meeting.
          </p>
        ) : (
          <>
            <div className="my-[8px]">
              <Timeline />
            </div>

            {!!needs.length && (
              <>
                <div className="pb-[8px] border-b border-b-[#e4e4e4]" ref={needsRef}>
                  <p className="text-[#3f424a] text-[26px] font-semibold font-['Manrope'] leading-[29.90px]">Needs</p>
                </div>

                <Needs />
              </>
            )}

            {!!problems.length && (
              <>
                <div className="pb-[8px] border-b border-b-[#e4e4e4]" ref={problemsRef}>
                  <p className="text-[#3f424a] text-[26px] font-semibold font-['Manrope'] leading-[29.90px]">
                    Pain Points
                  </p>
                </div>

                <div className="w-full flex flex-wrap relative">
                  <Problems
                    problems={problems}
                    setProblems={setProblems}
                    meetings={[{ ...meeting, url }]}
                    setProject={setProject}
                    project={project}
                    useTwoColumns
                  />
                </div>
              </>
            )}

            {!!qas.length && <QAs />}

            {!!feedbacks.length && (
              <>
                <div className="pb-[8px] border-b border-b-[#e4e4e4]" ref={feedbackRef}>
                  <p className="text-[#3f424a] text-[26px] font-semibold font-['Manrope'] leading-[29.90px]">
                    Feedback
                  </p>
                </div>

                <FeedbacksCanvas />
              </>
            )}
          </>
        )}

        <div>&nbsp;</div>
      </div>

      {/* Render EditDialog when dialogState.isOpen is true */}
      {dialogState.isOpen &&
        getEntityAndSetter() &&
        createPortal(
          <EditDialog
            {...getEntityAndSetter()}
            participants={participants}
            meeting={{ ...meeting, url }}
            project={project}
            categories={categories}
            close={closeDialog}
          />,
          document.body
        )}
    </div>
  )
}
